/* eslint-disable react/no-this-in-sfc */
/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import adminServices from '../../../services/adminServices';
import SnackBar from '../../../components/snackbar/snackbar';

export default function AddContentWriterForm(props) {
  
  const navigate = useNavigate()
  const [formValues, setFormValues] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarTitle, setSnackbarTitle] = React.useState('');
  const [selectedId, setSelectedId] = React.useState('');
  const [oldDetails, setOldDetails] = React.useState('');
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  useEffect(() => {
    if (props.mode === 'edit' && props.data) {
      setFormValues({
        firstName: props.data.first_name || '',
        lastName: props.data.last_name || '',
        email: props.data.email || '',
        phone: props.data.phone || '',
        newPassword: '',
        confirmPassword: '',
      });
      setOldDetails(`${props.data.first_name} ${props.data.last_name}`);
      setSelectedId(props.data.id);
    } else {
      setFormValues({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        newPassword: '',
        confirmPassword: '',
      });
    }
  }, [props.mode, props.data]);

  const getDuplicateFieldErrors = (values) => {
    const errors = {};
    if (!props.existingClients || props.existingClients.length === 0) return errors;
    props.existingClients.forEach((client) => {
      const firstNameMatch = client.first_name?.toLowerCase().trim() === values.firstName.toLowerCase().trim();
      const lastNameMatch = client.last_name?.toLowerCase().trim() === values.lastName.toLowerCase().trim();
      const emailMatch = client.email?.toLowerCase().trim() === values.email.toLowerCase().trim();
      if (props.mode === 'edit' && client.id === selectedId) return;
      if (props.mode === 'create' && emailMatch) errors.email = 'Email already exists';
      if (firstNameMatch && lastNameMatch) {
        errors.firstName = 'This name already exists';
        errors.lastName = 'This name already exists';
      }
    });
    return errors;
  };

  const handleSubmit = async (values, setFieldError) => {
    const duplicateErrors = getDuplicateFieldErrors(values);
    if (Object.keys(duplicateErrors).length > 0) {
      Object.entries(duplicateErrors).forEach(([field, message]) =>
        setFieldError(field, message)
      );
      return;
    }
  
    setLoading(true);
    const requestData = {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      email: values.email.trim(),
      contactPhone: values.phone?.trim() || '',
      password: values.newPassword || '',
      oldDetails,
    };
  
    try {
      const response =
        props.mode === 'create'
          ? await adminServices.postContentWriterList(requestData)
          : await adminServices.putContentWriterList(requestData, selectedId);
  
      if (response.ok || response.status === 400) {
        const message = response.data.message;
  
        setSnackbarTitle(message);
        setOpenSnackbar(true);
  
        if (message === "Email already exists.") {
          setLoading(false);
          return;
        }
  
        setTimeout(() => {
          setOpenSnackbar(false);
          props.getClientList();
          props.toggle();
  
          if (props.cominfrom === 'View') {
            props.updateDetails(requestData);
          }
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      setSnackbarTitle('An error occurred. Please try again.');
      setOpenSnackbar(true);
  
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 2000);
    }
  
    setLoading(false);
  };
  // const handleSubmit = async (values, setFieldError) => {
  //   const duplicateErrors = getDuplicateFieldErrors(values);
  //   if (Object.keys(duplicateErrors).length > 0) {
  //     Object.entries(duplicateErrors).forEach(([field, message]) => setFieldError(field, message));
  //     return;
  //   }

  //   setLoading(true);
  //   const requestData = {
  //     firstName: values.firstName,
  //     lastName: values.lastName,
  //     email: values.email,
  //     contactPhone: values.phone || '',
  //     password: values.newPassword || '',
  //     oldDetails,
  //   };

  //   try {
  //     const response = props.mode === 'create'  ? await adminServices.postContentWriterList(requestData): await adminServices.putContentWriterList(requestData, selectedId);

  //     if (response.ok) {
  //       setOpenSnackbar(true);
  //       setSnackbarTitle(response.data.message);
  //       props.getClientList();
  //       props.toggle();
  //       if(props.cominfrom === 'View'){
  //         props.updateDetails(requestData)
  //         // navigate('/app/content-writer-details')
  //       }
  //     } else if (response.status === 400) {
  //       setOpenSnackbar(true);
  //       setSnackbarTitle(response.data.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setOpenSnackbar(true);
  //     setSnackbarTitle('An error occurred. Please try again.');
  //   }
  //   setLoading(false);
  // };

  const isCreate = props.mode === 'create';
  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .min(3, 'Minimum 3 characters')
      .matches(/^[^\s]+(\s[^\s]+)*$/, 'Name cannot have leading, trailing or multiple spaces')
      .required('Name is required'),
    lastName: Yup.string()
      .trim()
      .min(3, 'Minimum 3 characters')
      .matches(/^[^\s]+(\s[^\s]+)*$/, 'Last name cannot have leading, trailing or multiple spaces')
      .required('Last name is required'),
    email: isCreate
      ? Yup.string().trim().required('Email is required').email('Must be a valid email')
      : Yup.string().trim(),
    phone: Yup.string()
      .nullable()
      .matches(/^[0-9+\-\s()]*$/, 'Invalid phone number')
      .min(7, 'Phone number too short'),
  
    newPassword: isCreate
      ? Yup.string().min(4, 'Minimum 4 characters').required('Password is required')
      : Yup.string().min(4, 'Minimum 4 characters').nullable(),
  
    confirmPassword: isCreate
  ? Yup.string().required('Confirm password is required')
  : Yup.string().nullable(),
  }).test('password-validation', '', function (values) {
    const { newPassword, confirmPassword } = values;
    const errors = [];
  
    if (!isCreate) {
      if (confirmPassword && !newPassword) {
        errors.push(this.createError({ path: 'newPassword', message: 'New password is required' }));
      }
      if (newPassword && !confirmPassword) {
        errors.push(this.createError({ path: 'confirmPassword', message: 'Confirm password is required' }));
      }
    }
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      errors.push(this.createError({ path: 'confirmPassword', message: 'Passwords must match' }));
    }
    if (errors.length > 0) throw errors[0];
    return true;
  });
  // const validationSchema = Yup.object().shape({
  //   firstName: Yup.string()
  //     .trim()
  //     .min(3, 'Minimum 3 characters')
  //     .required('Name is required'),
  
  //   lastName: Yup.string()
  //     .trim()
  //     .min(3, 'Minimum 3 characters')
  //     .required('Last name is required'),
  
  //   email: isCreate
  //     ? Yup.string()
  //         .trim()
  //         .required('Email is required')
  //         .email('Must be a valid email')
  //     : Yup.string().trim(),
  
  //   newPassword: isCreate
  //     ? Yup.string()
  //         .min(6, 'Minimum 6 characters')
  //         .required('Password is required')
  //     : Yup.string()
  //         .min(6, 'Minimum 6 characters')
  //         .nullable(),
  
  //   confirmPassword: Yup.string()
  //     .nullable()
  //     .when(['newPassword'], {
  //       is: (newPassword) => newPassword && newPassword.length > 0,
  //       then: (schema) =>
  //         schema
  //           .required('Confirm password is required')
  //           .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
  //       otherwise: (schema) => schema.notRequired(),
  //     }),
  // });

  let buttonText;

  if (loading) {
    buttonText = 'Saving...';
  } else if (isCreate) {
    buttonText = 'Create';
  } else {
    buttonText = 'Save Changes';
  }

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={formValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setFieldError }) => handleSubmit(values, setFieldError)}
      >
        {({ values, errors, touched, handleBlur, handleChange }) => (
          <Form style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ flex: 1, padding: '24px 24px 12px' }}>

              <div style={{ marginBottom: 20 }}>
                <label htmlFor='name' style={labelStyle}>
                  Name <span style={{ color: '#e53e3e' }}>*</span>

                  {isCreate ? (
                    <div style={{ display: 'flex', gap: 10 }}>
                      <div style={{ flex: 1 }}>
                        <input id='name'
                          name="firstName"
                          placeholder="First name"
                          value={values.firstName}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            if (/^\s/.test(e.target.value)) return;
                            handleChange(e);
                          }}
                          style={inputStyle(touched.firstName && errors.firstName)}
                        />
                        {touched.firstName && errors.firstName && (
                          <p style={errorStyle}>{errors.firstName}</p>
                        )}
                      </div>
                      <div style={{ flex: 1 }}>
                        <input
                          name="lastName"
                          placeholder="Last name"
                          value={values.lastName}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            if (/^\s/.test(e.target.value)) return;
                            handleChange(e);
                          }}
                          style={inputStyle(touched.lastName && errors.lastName)}
                        />
                        {touched.lastName && errors.lastName && (
                          <p style={errorStyle}>{errors.lastName}</p>
                        )}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ display: 'flex', gap: 10 }}>
                        <div style={{ flex: 1 }}>
                            <input
                              name="firstName"
                              placeholder="First name"
                              value={values.firstName}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                if (/^\s/.test(e.target.value)) return;
                                handleChange(e);
                              }}
                              style={inputStyle(touched.firstName && errors.firstName)}
                            />
                            {touched.firstName && errors.firstName && (
                              <p style={errorStyle}>{errors.firstName}</p>
                            )}
                          </div>
                          <div style={{ flex: 1 }}>
                            <input
                              name="lastName"
                              placeholder="Last name"
                              value={values.lastName}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                if (/^\s/.test(e.target.value)) return;
                                handleChange(e);
                              }}
                              style={inputStyle(touched.lastName && errors.lastName)}
                            />
                          {touched.lastName && errors.lastName && (
                            <p style={errorStyle}>{errors.lastName}</p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </label>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label htmlFor='email' style={labelStyle}>Email
                  <input id='email'
                    name="email"
                    type="email"
                    placeholder="creator@keyskillset.com"
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={!isCreate}
                    style={{
                      ...inputStyle(touched.email && errors.email),
                      backgroundColor: !isCreate ? '#f3f4f6' : '#fff',
                      color: !isCreate ? '#6b7280' : '#111827',
                      cursor: !isCreate ? 'not-allowed' : 'text',
                    }}
                  />
                </label>
                {touched.email && errors.email && <p style={errorStyle}>{errors.email}</p>}
                {!isCreate && (
                  <p style={{ margin: '4px 0 0', fontSize: 12, color: '#9ca3af' }}>
                    Email cannot be changed after creation.
                  </p>
                )}
              </div>

              <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '4px 0 20px' }} />

              <div style={{ marginBottom: 8 }}>
                <label style={labelStyle} htmlFor='password'>
                  {isCreate ? (
                    <>Password <span style={{ color: '#e53e3e' }}>*</span></>
                  ) : (
                    <>
                      New Password{' '}
                      <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 13 }}>
                        (leave blank to keep existing)
                      </span>
                    </>
                  )}
                </label>
                <div style={passwordWrapperStyle}>
                  <input
                    id='password'
                    name="newPassword"
                    type={showNewPassword ? 'text' : 'password'}
                    placeholder="Minimum 4 characters"
                    value={values.newPassword}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      if (/\s/.test(e.target.value)) return;
                      handleChange(e);
                    }}
                    style={{ ...inputStyle(touched.newPassword && errors.newPassword), paddingRight: 40 }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword((prev) => !prev)}
                    style={eyeBtnStyle}
                    tabIndex={-1}
                  >
                    {showNewPassword ? <EyeOff size={17} /> : <Eye size={17} />}
                  </button>
                </div>
                {errors.newPassword && (
                  <p style={errorStyle}>{errors.newPassword}</p>
                )}
              </div>

              <div style={{ marginBottom: 8 }}>
                <label style={labelStyle}>Confirm Password</label>
                <div style={passwordWrapperStyle}>
                  <input
                    name="confirmPassword"
                    type={showConfirmPassword ? 'text' : 'password'}
                    placeholder="Re-enter password"
                    value={values.confirmPassword}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      if (/\s/.test(e.target.value)) return;
                      handleChange(e);
                    }}
                    style={{ ...inputStyle(touched.confirmPassword && errors.confirmPassword), paddingRight: 40 }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    style={eyeBtnStyle}
                    tabIndex={-1}
                  >
                    {showConfirmPassword ? <EyeOff size={17} /> : <Eye size={17} />}
                  </button>
                </div>
                {touched.confirmPassword && errors.confirmPassword && (
                  <p style={errorStyle}>{errors.confirmPassword}</p>
                )}
              </div>
            </div>

            <div
              style={{
                borderTop: '1px solid #e5e7eb',
                padding: '16px 24px',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 10,
                backgroundColor: '#fff',
              }}
            >
              <button
                type="button"
                onClick={props.toggle}
                style={cancelBtnStyle}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f3f4f6' }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                style={{ ...submitBtnStyle, opacity: loading ? 0.7 : 1 }}
              >
                {buttonText}
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
    </>
  );
}

/* ── Styles ── */
const labelStyle = {
  display: 'block',
  marginBottom: 6,
  fontSize: 14,
  fontWeight: 600,
  color: '#111827',
};

const inputStyle = (hasError) => ({
  width: '100%',
  boxSizing: 'border-box',
  padding: '10px 14px',
  fontSize: 14,
  color: '#111827',
  backgroundColor: '#fff',
  border: `1px solid ${hasError ? '#e53e3e' : '#d1d5db'}`,
  borderRadius: 8,
  outline: 'none',
  transition: 'border-color 0.15s',
  fontFamily: 'inherit',
});

const passwordWrapperStyle = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
};

const eyeBtnStyle = {
  position: 'absolute',
  right: 10,
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: '#6B7280',
  display: 'flex',
  alignItems: 'center',
  padding: 0,
};

const errorStyle = {
  margin: '4px 0 0',
  fontSize: 12,
  color: '#e53e3e',
};

const cancelBtnStyle = {
  padding: '9px 20px',
  fontSize: 14,
  fontWeight: 500,
  color: '#374151',
  backgroundColor: '#fff',
  border: '1px solid #d1d5db',
  borderRadius: 8,
  cursor: 'pointer',
  transition: 'background-color 0.15s',
  fontFamily: 'inherit',
};

const submitBtnStyle = {
  padding: '9px 22px',
  fontSize: 14,
  fontWeight: 600,
  color: '#fff',
  backgroundColor: '#2563eb',
  border: 'none',
  borderRadius: 8,
  cursor: 'pointer',
  fontFamily: 'inherit',
  transition: 'opacity 0.15s',
};